import { ContactInfo } from '../types';
import { CIVILITE_OPTIONS } from './ContactStep';

// The API boundary between the funnel's French field names/values and the backend's English ones
// (backend-plan.md §7.1) — kept out of DemarcheFunnelStore so the store's fields stay a faithful
// mirror of what the forms collect, not a mix of two conventions.
const mapContactInfoToContactPayload = (situation: string | null, contactInfo: ContactInfo) => ({
  situation,
  salutation: contactInfo.civilite === CIVILITE_OPTIONS[0].value ? 'mr' : 'mrs',
  first_name: contactInfo.prenom,
  last_name: contactInfo.nom,
  email: contactInfo.email,
  phone: contactInfo.telephone,
});

// Same five fields, without `situation` — for PATCHing an existing order's contact details when
// the user edits them after the order was already created (DemarcheFunnelStore#createOrder), which
// `POST .../orders` (create) cannot do a second time since it is idempotent per slug+situation.
const mapContactInfoToOrderPatchPayload = (contactInfo: ContactInfo) => {
  const { situation: _situation, ...rest } = mapContactInfoToContactPayload(null, contactInfo);

  return rest;
};

export { mapContactInfoToContactPayload, mapContactInfoToOrderPatchPayload };
